import { createAction } from '@reduxjs/toolkit';
import type { IErrorType } from '../../constants/types';
import {
    types,
    type AcceptBrandOpsInvitePayload,
    type UpsertBrandOpsAutomationPayload,
    type ToggleBrandOpsAutomationPayload,
    type ApproveBrandOpsCalendarPayload,
    type PublishBrandOpsCalendarPayload,
    type AddBrandOpsKnowledgePayload,
    type RemoveBrandOpsKnowledgePayload,
    type BrandOpsAiPlaygroundPayload,
    type BrandOpsBrandPayload,
    type BrandOpsEscrowPeriodPayload,
    type BrandOpsAddStrikePayload,
    type BrandOpsConversationMessagesPayload,
    type BrandOpsSendInboxMessagePayload,
    type BrandOpsUgcAssetsPayload,
    type IBrandOpsKnowledgeDoc,
    type IBrandOpsAiPlaygroundResult,
    type IBrandOpsAutomationRule,
    type IBrandOpsInboxItem,
    type IBrandOpsInboxStatus,
    type IBrandOpsConversation,
    type IBrandOpsHomeStats,
    type IBrandOpsInboxMessage,
    type IBrandOpsUgcAsset,
    type IBrandOpsContractClarification,
    type ContractReviewTokenPayload,
    type IContractReview,
    type BrandOpsContractIdPayload,
    type BrandOpsContractActionPayload,
    type CreateBrandOpsCalendarPayload,
    type CreateBrandOpsContractPayload,
    type IBrandOpsAccess,
    type IBrandOpsCalendarItem,
    type IBrandOpsContract,
    type IBrandOpsSettings,
    type IBrandMembership,
    type IBrandOpsTeamMember,
    type InviteBrandOpsTeamPayload,
    type RemoveBrandOpsTeamMemberPayload,
    type SignBrandOpsContractPayload,
    type UpdateBrandOpsCalendarPayload,
    type UpdateBrandOpsSettingsPayload,
    type UpdateBrandOpsTeamMemberPayload,
} from './types';

export const fetchBrandOpsHomeStats = createAction<BrandOpsBrandPayload>(types.FETCH_HOME_STATS);
export const fetchBrandOpsHomeStatsSuccess = createAction<IBrandOpsHomeStats>(types.FETCH_HOME_STATS_SUCCESS);

export const fetchBrandOpsAccess = createAction<BrandOpsBrandPayload>(types.FETCH_ACCESS);
export const fetchBrandOpsAccessSuccess = createAction<IBrandOpsAccess>(types.FETCH_ACCESS_SUCCESS);
export const fetchBrandOpsAccessFail = createAction<IErrorType>(types.FETCH_ACCESS_FAIL);

export const fetchBrandOpsTeam = createAction<BrandOpsBrandPayload>(types.FETCH_TEAM);
export const fetchBrandOpsTeamSuccess = createAction<IBrandOpsTeamMember[]>(types.FETCH_TEAM_SUCCESS);
export const fetchBrandOpsTeamFail = createAction<IErrorType>(types.FETCH_TEAM_FAIL);

export const inviteBrandOpsTeam = createAction<InviteBrandOpsTeamPayload>(types.INVITE_TEAM);
export const inviteBrandOpsTeamSuccess = createAction<IBrandOpsTeamMember>(types.INVITE_TEAM_SUCCESS);
export const inviteBrandOpsTeamFail = createAction<IErrorType>(types.INVITE_TEAM_FAIL);

export const updateBrandOpsTeamMember = createAction<UpdateBrandOpsTeamMemberPayload>(types.UPDATE_TEAM_MEMBER);
export const updateBrandOpsTeamMemberSuccess = createAction<IBrandOpsTeamMember>(types.UPDATE_TEAM_MEMBER_SUCCESS);
export const updateBrandOpsTeamMemberFail = createAction<IErrorType>(types.UPDATE_TEAM_MEMBER_FAIL);

export const removeBrandOpsTeamMember = createAction<RemoveBrandOpsTeamMemberPayload>(types.REMOVE_TEAM_MEMBER);
export const removeBrandOpsTeamMemberSuccess = createAction<string>(types.REMOVE_TEAM_MEMBER_SUCCESS);
export const removeBrandOpsTeamMemberFail = createAction<IErrorType>(types.REMOVE_TEAM_MEMBER_FAIL);

export const acceptBrandOpsInvite = createAction<AcceptBrandOpsInvitePayload>(types.ACCEPT_TEAM_INVITE);
export const acceptBrandOpsInviteSuccess = createAction<IBrandOpsTeamMember | void>(types.ACCEPT_TEAM_INVITE_SUCCESS);
export const acceptBrandOpsInviteFail = createAction<IErrorType>(types.ACCEPT_TEAM_INVITE_FAIL);

export const fetchBrandOpsContracts = createAction<BrandOpsBrandPayload>(types.FETCH_CONTRACTS);
export const fetchBrandOpsContractsSuccess = createAction<IBrandOpsContract[]>(types.FETCH_CONTRACTS_SUCCESS);
export const fetchBrandOpsContractsFail = createAction<IErrorType>(types.FETCH_CONTRACTS_FAIL);

export const createBrandOpsContract = createAction<CreateBrandOpsContractPayload>(types.CREATE_CONTRACT);
export const createBrandOpsContractSuccess = createAction<IBrandOpsContract>(types.CREATE_CONTRACT_SUCCESS);
export const createBrandOpsContractFail = createAction<IErrorType>(types.CREATE_CONTRACT_FAIL);

export const getBrandOpsContract = createAction<BrandOpsContractIdPayload>(types.GET_CONTRACT);
export const getBrandOpsContractSuccess = createAction<IBrandOpsContract>(types.GET_CONTRACT_SUCCESS);
export const getBrandOpsContractFail = createAction<IErrorType>(types.GET_CONTRACT_FAIL);

export const dispatchBrandOpsContract = createAction<BrandOpsContractIdPayload>(types.DISPATCH_CONTRACT);
export const dispatchBrandOpsContractSuccess = createAction<IBrandOpsContract>(types.DISPATCH_CONTRACT_SUCCESS);
export const dispatchBrandOpsContractFail = createAction<IErrorType>(types.DISPATCH_CONTRACT_FAIL);

export const signBrandOpsContract = createAction<SignBrandOpsContractPayload>(types.SIGN_CONTRACT);
export const signBrandOpsContractSuccess = createAction<IBrandOpsContract>(types.SIGN_CONTRACT_SUCCESS);
export const signBrandOpsContractFail = createAction<IErrorType>(types.SIGN_CONTRACT_FAIL);

export const fetchBrandOpsCalendar = createAction<BrandOpsBrandPayload>(types.FETCH_CALENDAR);
export const fetchBrandOpsCalendarSuccess = createAction<IBrandOpsCalendarItem[]>(types.FETCH_CALENDAR_SUCCESS);
export const fetchBrandOpsCalendarFail = createAction<IErrorType>(types.FETCH_CALENDAR_FAIL);

export const createBrandOpsCalendarItem = createAction<CreateBrandOpsCalendarPayload>(types.CREATE_CALENDAR_ITEM);
export const createBrandOpsCalendarItemSuccess = createAction<IBrandOpsCalendarItem>(
    types.CREATE_CALENDAR_ITEM_SUCCESS,
);
export const createBrandOpsCalendarItemFail = createAction<IErrorType>(types.CREATE_CALENDAR_ITEM_FAIL);

export const updateBrandOpsCalendarItem = createAction<UpdateBrandOpsCalendarPayload>(types.UPDATE_CALENDAR_ITEM);
export const updateBrandOpsCalendarItemSuccess = createAction<IBrandOpsCalendarItem>(
    types.UPDATE_CALENDAR_ITEM_SUCCESS,
);
export const updateBrandOpsCalendarItemFail = createAction<IErrorType>(types.UPDATE_CALENDAR_ITEM_FAIL);

export const approveBrandOpsCalendarItem = createAction<ApproveBrandOpsCalendarPayload>(types.APPROVE_CALENDAR_ITEM);
export const approveBrandOpsCalendarItemSuccess = createAction<IBrandOpsCalendarItem>(
    types.APPROVE_CALENDAR_ITEM_SUCCESS,
);
export const approveBrandOpsCalendarItemFail = createAction<IErrorType>(types.APPROVE_CALENDAR_ITEM_FAIL);

export const publishBrandOpsCalendarItem = createAction<PublishBrandOpsCalendarPayload>(types.PUBLISH_CALENDAR_ITEM);
export const publishBrandOpsCalendarItemSuccess = createAction<IBrandOpsCalendarItem>(
    types.PUBLISH_CALENDAR_ITEM_SUCCESS,
);
export const publishBrandOpsCalendarItemFail = createAction<IErrorType>(types.PUBLISH_CALENDAR_ITEM_FAIL);

export const fetchBrandOpsSettings = createAction<BrandOpsBrandPayload>(types.FETCH_SETTINGS);
export const fetchBrandOpsSettingsSuccess = createAction<IBrandOpsSettings>(types.FETCH_SETTINGS_SUCCESS);
export const fetchBrandOpsSettingsFail = createAction<IErrorType>(types.FETCH_SETTINGS_FAIL);

export const updateBrandOpsSettings = createAction<UpdateBrandOpsSettingsPayload>(types.UPDATE_SETTINGS);
export const updateBrandOpsSettingsSuccess = createAction<IBrandOpsSettings>(types.UPDATE_SETTINGS_SUCCESS);
export const updateBrandOpsSettingsFail = createAction<IErrorType>(types.UPDATE_SETTINGS_FAIL);

export const downloadBrandOpsContractPdf = createAction<BrandOpsContractIdPayload>(types.DOWNLOAD_CONTRACT_PDF);
export const downloadBrandOpsContractPdfSuccess = createAction(types.DOWNLOAD_CONTRACT_PDF_SUCCESS);
export const downloadBrandOpsContractPdfFail = createAction<IErrorType>(types.DOWNLOAD_CONTRACT_PDF_FAIL);

export const fetchBrandOpsKnowledge = createAction<BrandOpsBrandPayload>(types.FETCH_KNOWLEDGE);
export const fetchBrandOpsKnowledgeSuccess = createAction<IBrandOpsKnowledgeDoc[]>(types.FETCH_KNOWLEDGE_SUCCESS);
export const fetchBrandOpsKnowledgeFail = createAction<IErrorType>(types.FETCH_KNOWLEDGE_FAIL);

export const addBrandOpsKnowledge = createAction<AddBrandOpsKnowledgePayload>(types.ADD_KNOWLEDGE);
export const addBrandOpsKnowledgeSuccess = createAction<IBrandOpsKnowledgeDoc>(types.ADD_KNOWLEDGE_SUCCESS);
export const addBrandOpsKnowledgeFail = createAction<IErrorType>(types.ADD_KNOWLEDGE_FAIL);

export const removeBrandOpsKnowledge = createAction<RemoveBrandOpsKnowledgePayload>(types.REMOVE_KNOWLEDGE);
export const removeBrandOpsKnowledgeSuccess = createAction<string>(types.REMOVE_KNOWLEDGE_SUCCESS);
export const removeBrandOpsKnowledgeFail = createAction<IErrorType>(types.REMOVE_KNOWLEDGE_FAIL);

export const runBrandOpsAiPlayground = createAction<BrandOpsAiPlaygroundPayload>(types.AI_PLAYGROUND);
export const runBrandOpsAiPlaygroundSuccess = createAction<IBrandOpsAiPlaygroundResult>(types.AI_PLAYGROUND_SUCCESS);
export const runBrandOpsAiPlaygroundFail = createAction<IErrorType>(types.AI_PLAYGROUND_FAIL);

export const fetchBrandOpsInbox = createAction<BrandOpsBrandPayload>(types.FETCH_INBOX);
export const fetchBrandOpsInboxSuccess = createAction<IBrandOpsInboxItem[]>(types.FETCH_INBOX_SUCCESS);
export const fetchBrandOpsInboxFail = createAction<IErrorType>(types.FETCH_INBOX_FAIL);

export const fetchBrandOpsInboxStatus = createAction<BrandOpsBrandPayload>(types.FETCH_INBOX_STATUS);
export const fetchBrandOpsInboxStatusSuccess = createAction<IBrandOpsInboxStatus>(types.FETCH_INBOX_STATUS_SUCCESS);
export const fetchBrandOpsInboxStatusFail = createAction<IErrorType>(types.FETCH_INBOX_STATUS_FAIL);

export const lockBrandOpsEscrow = createAction<BrandOpsEscrowPeriodPayload>(types.LOCK_ESCROW);
export const lockBrandOpsEscrowSuccess = createAction<IBrandOpsContract>(types.LOCK_ESCROW_SUCCESS);
export const lockBrandOpsEscrowFail = createAction<IErrorType>(types.LOCK_ESCROW_FAIL);

export const payoutBrandOpsEscrow = createAction<BrandOpsEscrowPeriodPayload>(types.PAYOUT_ESCROW);
export const payoutBrandOpsEscrowSuccess = createAction<IBrandOpsContract>(types.PAYOUT_ESCROW_SUCCESS);
export const payoutBrandOpsEscrowFail = createAction<IErrorType>(types.PAYOUT_ESCROW_FAIL);

export const releaseBrandOpsEscrow = createAction<BrandOpsEscrowPeriodPayload>(types.RELEASE_ESCROW);
export const releaseBrandOpsEscrowSuccess = createAction<IBrandOpsContract>(types.RELEASE_ESCROW_SUCCESS);
export const releaseBrandOpsEscrowFail = createAction<IErrorType>(types.RELEASE_ESCROW_FAIL);

export const addBrandOpsStrike = createAction<BrandOpsAddStrikePayload>(types.ADD_STRIKE);
export const addBrandOpsStrikeSuccess = createAction<IBrandOpsContract>(types.ADD_STRIKE_SUCCESS);
export const addBrandOpsStrikeFail = createAction<IErrorType>(types.ADD_STRIKE_FAIL);

export const fetchBrandOpsConversations = createAction<BrandOpsBrandPayload>(types.FETCH_CONVERSATIONS);
export const fetchBrandOpsConversationsSuccess = createAction<IBrandOpsConversation[]>(
    types.FETCH_CONVERSATIONS_SUCCESS,
);
export const fetchBrandOpsConversationsFail = createAction<IErrorType>(types.FETCH_CONVERSATIONS_FAIL);

export const fetchBrandOpsConversationMessages = createAction<BrandOpsConversationMessagesPayload>(
    types.FETCH_CONVERSATION_MESSAGES,
);
export const fetchBrandOpsConversationMessagesSuccess = createAction<IBrandOpsInboxMessage[]>(
    types.FETCH_CONVERSATION_MESSAGES_SUCCESS,
);
export const fetchBrandOpsConversationMessagesFail = createAction<IErrorType>(types.FETCH_CONVERSATION_MESSAGES_FAIL);

export const sendBrandOpsInboxMessage = createAction<BrandOpsSendInboxMessagePayload>(types.SEND_INBOX_MESSAGE);
export const sendBrandOpsInboxMessageSuccess = createAction(types.SEND_INBOX_MESSAGE_SUCCESS);
export const sendBrandOpsInboxMessageFail = createAction<IErrorType>(types.SEND_INBOX_MESSAGE_FAIL);

export const fetchBrandOpsUgcAssets = createAction<BrandOpsUgcAssetsPayload>(types.FETCH_UGC_ASSETS);
export const fetchBrandOpsUgcAssetsSuccess = createAction<IBrandOpsUgcAsset[]>(types.FETCH_UGC_ASSETS_SUCCESS);
export const fetchBrandOpsUgcAssetsFail = createAction<IErrorType>(types.FETCH_UGC_ASSETS_FAIL);

export const fetchMyBrandMemberships = createAction(types.FETCH_MY_MEMBERSHIPS);
export const fetchMyBrandMembershipsSuccess = createAction<IBrandMembership[]>(types.FETCH_MY_MEMBERSHIPS_SUCCESS);
export const fetchMyBrandMembershipsFail = createAction<IErrorType>(types.FETCH_MY_MEMBERSHIPS_FAIL);

export const fetchMyBrandOpsContract = createAction<BrandOpsBrandPayload>(types.FETCH_MY_CONTRACT);
export const fetchMyBrandOpsContractSuccess = createAction<IBrandOpsContract | null>(types.FETCH_MY_CONTRACT_SUCCESS);
export const fetchMyBrandOpsContractFail = createAction<IErrorType>(types.FETCH_MY_CONTRACT_FAIL);

export const approveBrandOpsContract = createAction<BrandOpsContractIdPayload>(types.APPROVE_CONTRACT);
export const approveBrandOpsContractSuccess = createAction<IBrandOpsContract>(types.APPROVE_CONTRACT_SUCCESS);
export const approveBrandOpsContractFail = createAction<IErrorType>(types.APPROVE_CONTRACT_FAIL);

export const getContractForReview = createAction<ContractReviewTokenPayload>(types.GET_CONTRACT_FOR_REVIEW);
export const getContractForReviewSuccess = createAction<IContractReview>(types.GET_CONTRACT_FOR_REVIEW_SUCCESS);
export const getContractForReviewFail = createAction<IErrorType>(types.GET_CONTRACT_FOR_REVIEW_FAIL);

export const resendBrandOpsTeamInvite = createAction<RemoveBrandOpsTeamMemberPayload>(types.RESEND_TEAM_INVITE);
export const resendBrandOpsTeamInviteSuccess = createAction<IBrandOpsTeamMember>(types.RESEND_TEAM_INVITE_SUCCESS);
export const resendBrandOpsTeamInviteFail = createAction<IErrorType>(types.RESEND_TEAM_INVITE_FAIL);

export const renewBrandOpsContract = createAction<BrandOpsContractIdPayload>(types.RENEW_CONTRACT);
export const renewBrandOpsContractSuccess = createAction<IBrandOpsContract>(types.RENEW_CONTRACT_SUCCESS);
export const renewBrandOpsContractFail = createAction<IErrorType>(types.RENEW_CONTRACT_FAIL);

export const freezeBrandOpsContract = createAction<BrandOpsContractActionPayload>(types.FREEZE_CONTRACT);
export const freezeBrandOpsContractSuccess = createAction<IBrandOpsContract>(types.FREEZE_CONTRACT_SUCCESS);
export const freezeBrandOpsContractFail = createAction<IErrorType>(types.FREEZE_CONTRACT_FAIL);

export const voidBrandOpsContract = createAction<BrandOpsContractActionPayload>(types.VOID_CONTRACT);
export const voidBrandOpsContractSuccess = createAction<IBrandOpsContract>(types.VOID_CONTRACT_SUCCESS);
export const voidBrandOpsContractFail = createAction<IErrorType>(types.VOID_CONTRACT_FAIL);

export const fetchBrandOpsAutomations = createAction<BrandOpsBrandPayload>(types.FETCH_AUTOMATIONS);
export const fetchBrandOpsAutomationsSuccess = createAction<IBrandOpsAutomationRule[]>(types.FETCH_AUTOMATIONS_SUCCESS);
export const fetchBrandOpsAutomationsFail = createAction<IErrorType>(types.FETCH_AUTOMATIONS_FAIL);

export const upsertBrandOpsAutomation = createAction<UpsertBrandOpsAutomationPayload>(types.UPSERT_AUTOMATION);
export const upsertBrandOpsAutomationSuccess = createAction<IBrandOpsAutomationRule>(types.UPSERT_AUTOMATION_SUCCESS);
export const upsertBrandOpsAutomationFail = createAction<IErrorType>(types.UPSERT_AUTOMATION_FAIL);

export const toggleBrandOpsAutomation = createAction<ToggleBrandOpsAutomationPayload>(types.TOGGLE_AUTOMATION);
export const toggleBrandOpsAutomationSuccess = createAction<IBrandOpsAutomationRule>(types.TOGGLE_AUTOMATION_SUCCESS);
export const toggleBrandOpsAutomationFail = createAction<IErrorType>(types.TOGGLE_AUTOMATION_FAIL);

export const deleteBrandOpsAutomation = createAction<{ brandId: string; automationId: string }>(
    types.DELETE_AUTOMATION,
);
export const deleteBrandOpsAutomationSuccess = createAction<{ automationId: string }>(types.DELETE_AUTOMATION_SUCCESS);
export const deleteBrandOpsAutomationFail = createAction<IErrorType>(types.DELETE_AUTOMATION_FAIL);

export const fetchContractClarifications = createAction<{ brandId: string; contractId: string }>(
    types.FETCH_CONTRACT_CLARIFICATIONS,
);
export const fetchContractClarificationsSuccess = createAction<IBrandOpsContractClarification[]>(
    types.FETCH_CONTRACT_CLARIFICATIONS_SUCCESS,
);
export const fetchContractClarificationsFail = createAction<IErrorType>(types.FETCH_CONTRACT_CLARIFICATIONS_FAIL);

export const replyToContractClarification = createAction<{
    brandId: string;
    contractId: string;
    clarificationId: string;
    reply: string;
}>(types.REPLY_TO_CLARIFICATION);
export const replyToContractClarificationSuccess = createAction<IBrandOpsContractClarification>(
    types.REPLY_TO_CLARIFICATION_SUCCESS,
);
export const replyToContractClarificationFail = createAction<IErrorType>(types.REPLY_TO_CLARIFICATION_FAIL);

export const brandOpsNewClarificationReceived = createAction<{
    contract_id: string;
    clarification_id: string;
    manager_email: string;
    message: string;
}>(types.BRAND_OPS_NEW_CLARIFICATION);

export const brandOpsContractSignedReceived = createAction<{
    contract_id: string;
    manager_email: string;
    manager_name: string;
    requires_approval: boolean;
}>(types.BRAND_OPS_CONTRACT_SIGNED);

export const brandOpsContractDeclinedReceived = createAction<{ manager_email: string; reason: string | null }>(
    types.BRAND_OPS_CONTRACT_DECLINED,
);

export const brandOpsNewDmReceived = createAction<{
    ig_user_id: string;
    sender_id: string;
    message_id: string;
    text: string;
    timestamp: number;
}>(types.BRAND_OPS_NEW_DM);
